module.exports = __webpack_public_path__ + "img/crotch height.721f94a2.png";